import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { appLayout } from './AppLayout';
import { ssoRijkAuthApi } from './auth';
import { pageLayout } from './PageLayout';
import { darkTheme, lightTheme } from './theme';
import { topNavigation } from './TopNavigation';
import { dutchTranslations } from './translations';

export { techdocsStyleModule } from './techdocsStyle';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: () => import('./SignIn').then(module => module.SignIn),
  },
});

export const shellModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    appLayout,
    pageLayout,
    topNavigation,
    signInPage,
    ssoRijkAuthApi,
    lightTheme,
    darkTheme,
    ...dutchTranslations,
  ],
});
